import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ProjectNavigation from "../components/ProjectNavigation";
import ResponsiveImage from "../components/ResponsiveImage";

const AdaptiveStudy = () => {
  // Jacket render images
  const jacketRenderImages = [
    "/images/projects/Adaptive Study/Renders/Jacket front",
    "/images/projects/Adaptive Study/Renders/Jacket detail"
  ];

  // Boot render images
  const bootRenderImages = [
    "/images/projects/Adaptive Study/Renders/Bottom45",
    "/images/projects/Adaptive Study/Renders/Frontboth",
    "/images/projects/Adaptive Study/Renders/Medial45",
    "/images/projects/Adaptive Study/Renders/MedialAbove"
  ];

  // Other images
  const posterImage = "/images/projects/Adaptive Study/Adaptive Study Poster";
  const patternImage = "/images/projects/Adaptive Study/pattern";

  // Function to create an open in new tab button
  const OpenInNewTabButton = ({ imagePath }) => (
    <a 
      href={`${imagePath}.webp`} 
      target="_blank" 
      rel="noopener noreferrer"
      className="open-in-new-tab-btn"
    >
      Open in new tab
    </a>
  );

  return (
    <div>
      <Header />
      <ProjectNavigation currentProject="/adaptive-study" />
      
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "30px 20px" }}>
        <h1 style={{ textAlign: "center", marginBottom: "40px" }}>Adaptive Study</h1>
        
        <p style={{
          maxWidth: "800px",
          margin: "20px auto 40px",
          fontSize: "16px",
          lineHeight: "1.6",
          color: "#333",
          padding: "0 20px",
          textAlign: "center"
        }}>
          My adaptive study project was created through instruction of senior professor Dr. Kristen Morris, an expert in adaptive design. She worked with me to determine that I should create a project heavily utilizing 3D prototyping software to realize a design concept that the market had not seen before. Additonally, we worked together to create the goal to use Clo3D, a 3D design software not traditonally used for footwear, to create a footwear concept and document the process.
        </p>

        {/* Jacket Renders Section */}
        <section style={{ marginBottom: "60px" }}>
          <h2 style={{ marginBottom: "30px" }}>Interface Coat 3D Renders</h2>
          <div style={{ 
            display: "grid", 
            gridTemplateColumns: "repeat(2, 1fr)", 
            gap: "30px" 
          }}>
            {jacketRenderImages.map((img, index) => (
              <div key={`jacket-render-${index}`} style={{ 
                position: "relative",
                width: "100%"
              }}>
                <ResponsiveImage
                  src={`${img}.png`}
                  webpSrc={`${img}.webp`}
                  alt={`Adaptive Jacket Render ${index + 1}`}
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "contain"
                  }}
                />
                <OpenInNewTabButton imagePath={img} />
              </div>
            ))}
          </div>
        </section>

        {/* Boot Renders Section */}
        <section style={{ marginBottom: "60px" }}>
          <h2 style={{ marginBottom: "30px" }}>Spiral Boot 3D Renders</h2>
          <div style={{ 
            display: "grid", 
            gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 500px), 1fr))", 
            gap: "30px" 
          }}>
            {bootRenderImages.map((img, index) => (
              <div key={`boot-render-${index}`} style={{ 
                position: "relative",
                width: "100%"
              }}>
                <ResponsiveImage
                  src={`${img}.png`}
                  webpSrc={`${img}.webp`}
                  alt={`Adaptive Boot Render ${index + 1}`}
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "contain"
                  }}
                />
                <OpenInNewTabButton imagePath={img} />
              </div>
            ))}
          </div>
        </section>

        {/* Boot Pattern Section */}
        <section style={{ marginBottom: "60px" }}>
          <h2 style={{ marginBottom: "30px" }}>Spiral Boot Upper and Sole Pattern</h2>
          <div style={{ 
            position: "relative",
            width: "100%",
            maxWidth: "800px",
            margin: "0 auto"
          }}>
            <ResponsiveImage
              src={`${patternImage}.png`}
              webpSrc={`${patternImage}.webp`}
              alt="Adaptive Boot Pattern"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "contain"
              }}
            />
            <OpenInNewTabButton imagePath={patternImage} />
          </div>
        </section>

        {/* Poster Section */}
        <section style={{ marginBottom: "60px" }}>
          <h2 style={{ marginBottom: "30px" }}>Project Poster</h2>
          <div style={{ 
            position: "relative",
            width: "100%",
            maxWidth: "800px",
            margin: "0 auto"
          }}>
            <ResponsiveImage
              src={`${posterImage}.jpg`}
              webpSrc={`${posterImage}.webp`}
              alt="Adaptive Study Poster"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "contain"
              }}
            />
            <OpenInNewTabButton imagePath={posterImage} />
          </div>
        </section>
      </div>
      
      <Footer />
    </div>
  );
};

export default AdaptiveStudy;
